import { createAction } from '@reduxjs/toolkit';
import { produce } from 'immer';

import type { RootState } from '@polyai/stream/store';
import { sliceReducers } from '@polyai/stream/store';

export const overwriteState = createAction<{
  state: RootState;
}>(`draft/overwriteState`);

export const applyOverwriteState = (
  state: RootState,
  action: ReturnType<typeof overwriteState>,
) => {
  const { state: newState } = action.payload;
  const keys = Object.keys(sliceReducers) as Array<keyof typeof sliceReducers>;

  return produce(state, draft => {
    if (!draft) {
      return;
    }
    for (const key of keys) {
      if (key in draft) {
        delete draft[key];
        if (key in newState) {
          // biome-ignore lint/suspicious/noExplicitAny: Dynamic state assignment
          draft[key] = newState[key] as any;
        }
      }
    }
  });
};
